// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3vENk","choiceBoxes":"toolbarselects_choiceBoxes__3elhG","simpleField":"toolbarselects_simpleField__BPJwK"};